import { render } from "./addSwiper.vue?vue&type=template&id=17ad9e77&scoped=true"
import script from "./addSwiper.vue?vue&type=script&lang=js"
export * from "./addSwiper.vue?vue&type=script&lang=js"

import "./addSwiper.vue?vue&type=style&index=0&id=17ad9e77&lang=less&scoped=true"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ad9e77"]])

export default __exports__